import { formatDistance } from 'date-fns';

const formatTimeString = (str, opts = {}) => {
  let [hour, minute] = String(str || '').split(':');
  const amPm = hour >= 12 ? 'pm' : 'am';
  hour = hour > 12 ? hour - 12 : hour;
  minute = String(minute).padStart(2, '0');
  hour = parseFloat(hour) === 0 ? '12' : hour;
  if (!opts.object) {
    return `${parseFloat(hour || 0)}:${minute}${amPm}`;
  }
  return { time: `${parseFloat(hour || 0)}:${minute}`, amPm };
};

const evaluateScheduleMessage = ({ args = {} }) => {
  if (!args.interval && args?.scheduleType === 'fixed' && !args?.runTimes?.length && !args?.days?.length) {
    return 'Schedule';
  }

  const weekdays = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
  const substitutions = {
    'every day': 'daily',
    'every week': 'weekly',
    'every month': 'monthly'
  };

  let title = '';

  if (args?.scheduleType === 'fixed' && args?.runTimes?.length) {
    const maxItems = 2;
    const formattedRunTimes = args.runTimes.slice(0, maxItems).map((time) => formatTimeString(time));
    title = `Run at ${formattedRunTimes.join(', ')}`;
    if (args.runTimes.length > maxItems) {
      title += ` and ${args.runTimes.length - maxItems} other times`;
    }
  } else {
    const distance = formatDistance(new Date(), new Date(Date.now() + args.interval || 0), { addSuffix: false }).replace('about ', '');
    title = `Run every ${distance}`;
    title = title.replace(`every 1 `, 'every ');

    if (args?.time) {
      title = `${title} at ${formatTimeString(args.time)}`;
    }
  }

  const daysString = (args?.days || []).join(',').trim();
  if (daysString.length > 0) {
    const daysMessage = args?.days?.length === 7 ? ', every day' : daysString === '1,2,3,4,5' ? ', only on weekdays' : daysString === '0,6' ? ', only on weekends' : args.days.length === 1 ? `, only on ${weekdays[args.days[0]]}` : `, only ${args.days?.length} days a week`;
    title = `${title} ${daysMessage}`;
  }
  title = title.replace(` ,`, `,`);
  for (const key in substitutions) {
    title = title.replace(key, substitutions[key]);
  }
  title = ['?', '.'].includes(title[title.length - 1]) ? title : `${title}`;

  return title;
};

export default evaluateScheduleMessage;
